import { Product } from 'schema-dts'
import { helmetJsonLdProp } from 'react-schemaorg'
import { useShop } from 'shop/hooks'
import { Helmet } from 'react-helmet-async'
import { createOffers, trimUrl } from './utils'
import { CategoryProduct } from '../Shop/Categories'

interface Props {
  product: CategoryProduct
}

export const ProductMeta = ({ product }: Props) => {
  const { currentPartnerStore, partner } = useShop()
  const { name: storeName } = currentPartnerStore || {}
  const { seo, name: partnerName } = partner || {}

  const baseUrl = trimUrl(window.location.origin + window.location.pathname)

  if (!seo?.enabled) {
    return <></>
  }
  // TODO: Fix the type of offers instead of using 'any'
  return (
    <Helmet
      script={[
        helmetJsonLdProp<Product>({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: product.name,
          url: baseUrl,
          image: product.images.map((image) => image.standard),
          description: product.description || '',
          sku: product.id,
          brand: {
            '@type': 'Brand',
            name: partnerName || ''
          },
          offers: createOffers(
            product,
            `${partnerName} ${storeName}`,
            baseUrl
          ) as any
        })
      ]}
    />
  )
}
